import { Notice } from '@applyboard/crystal-ui';
import { ZodErrorViewer } from 'zod-error-viewer';
import { ZodError } from 'zod';
import { getDataFromError } from '@applyboard/ui-utils';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function ErrorFallback(_ref) {
  var error = _ref.error,
    message = _ref.message;
  return _jsxs(Notice, {
    intent: "negative",
    children: [message, _jsxs("details", {
      children: [_jsx("summary", {
        style: {
          cursor: 'pointer'
        },
        children: "Show technical details"
      }), _jsxs("pre", {
        style: {
          padding: '8px',
          fontFamily: 'monospace',
          whiteSpace: 'normal',
          backgroundColor: 'rgba(0,0,0,0.05)',
          fontSize: '11px',
          wordBreak: 'break-word'
        },
        children: [error instanceof ZodError && _jsxs(_Fragment, {
          children: [_jsx("b", {
            style: {
              display: 'block'
            },
            children: "Validation Issues"
          }), _jsx(ZodErrorViewer, {
            data: getDataFromError(error),
            error: error
          }), _jsx("b", {
            style: {
              display: 'block'
            },
            children: "Stack Trace"
          })]
        }), error instanceof Error ? error.stack : '']
      })]
    })]
  });
}